import axios from 'axios';
import requests from '../util';
const { request } = requests;
const generateResponseForNimbus = ({
  emailID,
  inputFiles,
  requestType,
}) => {
  return request({
    url: '/api/v1/request/createRequest',
    method: 'post',
    body: { 'notificationMetaData':{'emailIds':emailID}, inputFiles, requestType },
  });
};

const generateApi = { generateResponseForNimbus };

export default generateApi;
